import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { AssetsUser, ELECTRICAL_ASPECT_TYPE, ElectricalAspect, setDefaultLocationFromUser } from 'assets-model';
import { ElectricalAspectService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class ElectricalAspectItemComponentBase extends CrudItemComponent<ElectricalAspect, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  

  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected electricalAspectService: ElectricalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(ELECTRICAL_ASPECT_TYPE, fb, elementRef, router, route, userStorage, dialog, electricalAspectService, injector, snackbar);
  }

  createNewItem() {
    return new ElectricalAspect();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      aspectAssetId: [null, []],
      lockVersion: [null, []],
      portableApplianceTestingDays: [null, [requiredValidator,]]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.aspectAssetId?.disable();
    }
  }
  
  
  lockVersionChanging(value: number, unsetDependents: boolean = true) {}
  
  lockVersionChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.lockVersionChangedByUser(value, unsetDependents);
    }
  }  
  
  lockVersionChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  portableApplianceTestingDaysChanging(value: number, unsetDependents: boolean = true) {}
  
  portableApplianceTestingDaysChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.portableApplianceTestingDaysChangedByUser(value, unsetDependents);
    }
  }  
  
  portableApplianceTestingDaysChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get aspectAssetId() {
    return this.control('aspectAssetId');
  }
  
  get lockVersion() {
    return this.control('lockVersion');
  }
  
  get portableApplianceTestingDays() {
    return this.control('portableApplianceTestingDays');
  }
  
}





